/**
 * Client -- everything we need to know to communicate with our backend server.
 *
 * Contains request functions and message types for talking to Conduit server.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const Client = (server, token) => {
    return {
        user: {
            get: () => send('GET', '/user'),
            put: (user) => send('PUT', '/user', { user }),
        },
        login: {
            post: (e, p) => send('POST', '/users/login', { user: { email: e, password: p } })
        },
        users: {
            post: (u, e, p) => send('POST', '/users', { user: { username: u, email: e, password: p } }),
        },
        profiles: {
            get: (user) => send('GET', `/profiles/${user}`)
        },
        follow: {
            post: (user) => send('POST', `/profiles/${user}/follow`),
            del: (user) => send('DELETE', `/profiles/${user}/follow`),
        },
        articles: {
            get: (q = {}) => send('GET', '/articles' + query(q)),
            post: (article) => send('POST', '/articles', { article })
        },
        article: {
            get: (slug) => send('GET', `/articles/${slug}`),
            put: (article) => send('PUT', `/articles/${article.slug}`, { article }),
            del: (slug) => send('DELETE', `/articles/${slug}`),
        },
        comments: {
            get: (slug) => send('GET', `/articles/${slug}/comments`),
            post: (slug, body) => send('POST', `/articles/${slug}/comments`, { comment: { body } })
        },
        comment: {
            del: (slug, id) => send('DELETE', `/articles/${slug}/comments/${id}`)
        },
        feed: {
            get: (q = {}) => send('GET', '/articles/feed' + query(q))
        },
        tags: {
            get: () => send('GET', '/tags'),
        },
        favorite: {
            post: (slug) => send('POST', `/articles/${slug}/favorite`),
            del: (slug) => send('DELETE', `/articles/${slug}/favorite`),
        }
    };
    // base send utility, defines out conventions for talking to server:
    // what our auth header is, non-success throws, etc.
    function send(method, url, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = {}, opts = { method, headers };
            if (data !== undefined) {
                headers['Content-Type'] = 'application/json';
                opts.body = JSON.stringify(data);
            }
            if (token()) {
                headers['Authorization'] = `Token ${token()}`;
            }
            const response = yield fetch(server + url, opts);
            // unlike native fetch(), throw on non-success
            if (response.status !== 200)
                throw response;
            return response.json();
        });
    }
}, 
/**
 * Does the given rejection value represent an authentication failure?
 *
 * Used to determine whether to attempt to (re)login and re-try request.
 */
isAuthFailure = (e) => e instanceof Response && e.status === 401, 
/**
 * Utility to convert an object of key-values into a query string
 */
query = (q) => Object.keys(q)
    .filter(p => q[p] !== undefined)
    // weird, the Conduit server doesn't expect these params to be escaped and fails on them if so :/
    //.map((p, i) => `${i ? '&' : '?'}${encodeURIComponent(p)}=${encodeURIComponent(q[p]!)}`)
    .map((p, i) => `${i ? '&' : '?'}${p}=${q[p]}`)
    .join('');
